export default "__VITE_ASSET__4cf8ad51__"